export const socialNetworksURLs = {
  fetch: '/v1/users/socials',
  connect: (userId: number): string => `/v1/users/${userId}/social`,
  disconnect: (userId: number, platform: string): string => `/v1/users/${userId}/social/${platform}`
};
